import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import { PLANS } from '../../data/plans';
import {
  ISubscriptionPlan,
  SubscriptionPlan,
} from '../../model/subscription-plan';
import { IPlansApiService } from './plans-api.interface';

@Injectable({
  providedIn: 'root',
})
export class PlansMockApiService
  implements IPlansApiService
{
  data = {
    subscription_plans: {
      items: [...PLANS],
      queryOptions: { page: 1, size: 10 } as QueryOptions<ISubscriptionPlan>,
      subject: new BehaviorSubject<Maybe<SubscriptionPlan[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get subscriptionPlansData() {
    return this.data['subscription_plans'] as Data<
      SubscriptionPlan,
      ISubscriptionPlan
    >;
  }
}
